import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { PlusIcon } from "@heroicons/vue/24/outline";
import isMobile from "is-mobile";
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useLastSelectedDashboardId } from "@/composables/dashboard";
import { Dashboard } from "@/types/Dashboard";
import {
  useDashboardsWithDefault,
  useHasPermissionToEditDashboard,
  useLayoutContext,
} from "@/views/dashboard/composables";
import { createDashboardMenuCategories } from "@/views/dashboard/services/projectOverviewV2Layout";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarDashboardMenu',
  props: {
  isMobileMenu: {
    type: Boolean,
  },
},
  emits: ["addNewDashboard", "currentDashboardChanged"],
  setup(__props, { emit: __emit }) {



const { t } = useI18n();

const router = useRouter();
const currentDashboardId = useLastSelectedDashboardId();

const { layoutContext, isLoading: isLayoutContextLoading } = useLayoutContext();
const { dashboardsWithDefault, isLoading: areDashboardsLoading } =
  useDashboardsWithDefault(layoutContext);
const isLoading = computed(() => areDashboardsLoading.value || isLayoutContextLoading.value);

const currentDashboard = computed<Dashboard>(
  () =>
    dashboardsWithDefault.value.find((dashboard) => dashboard._id === currentDashboardId.value) ||
    dashboardsWithDefault.value.find((dashboard) => dashboard.default) ||
    dashboardsWithDefault.value[0],
);

const canEdit = computed(
  () =>
    !!currentDashboard.value &&
    !!layoutContext.value &&
    !isLoading.value &&
    !isMobile({ tablet: true, featureDetect: true }),
);
const hasPermissionToEditDashboard = useHasPermissionToEditDashboard();

const categories = computed(() =>
  createDashboardMenuCategories(dashboardsWithDefault.value).map((category) => ({
    ...category,
    canAdd: canEdit.value && hasPermissionToEditDashboard(category),
  })),
);

const handleMenuItemClick = (dashboard: Dashboard) => {
  if (dashboard._id !== "default") {
    router.push({
      name: "ProjectOverview",
      query: { id: dashboard._id },
    });
  } else {
    router.push({ name: "ProjectOverview" });
  }
};

const emit = __emit;

watch(currentDashboard, () => {
  emit("currentDashboardChanged", currentDashboard.value._id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex flex-col gap-2', __props.isMobileMenu && 'pt-2'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "flex flex-col gap-2"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
          'pr-3 font-semibold cursor-default flex items-center justify-between',
          __props.isMobileMenu ? 'text-gray-400' : 'text-white',
        ])
        }, [
          _createTextVNode(_toDisplayString(_unref(t)(`dashboard.menu_categories.${category.type}`)) + " ", 1),
          _createVNode(_unref(PlusIcon), {
            class: "w-4 h-4 cursor-pointer shrink-0 outline-none hover:text-yellow-400",
            onClick: ($event: any) => (emit('addNewDashboard', category.type))
          }, null, 8, ["onClick"])
        ], 2),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.dashboards, (dashboard) => {
            return (_openBlock(), _createElementBlock("li", {
              key: dashboard._id,
              class: _normalizeClass([
            currentDashboard.value?._id === dashboard._id ? 'text-yellow-400' : 'hover:text-yellow-400',
            'gap-x-3 flex group hover:border-white cursor-pointer text-sm leading-6',
            __props.isMobileMenu ? 'text-gray-400' : 'border-l border-gray-400 ',
          ]),
              onClick: ($event: any) => (handleMenuItemClick(dashboard))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass([
              'w-full flex items-center gap-1 py-1 px-2 rounded-md hover:bg-oaiGray-300',
              !__props.isMobileMenu && 'mx-2',
            ])
              }, _toDisplayString(dashboard.name), 3)
            ], 10, _hoisted_1))
          }), 128))
        ])
      ]))
    }), 128))
  ], 2))
}
}

})